import {Button, Col, Row} from "react-bootstrap";
import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import API from "../api/api";
import { useNavigate } from "react-router-dom";

function EmailConfirmation() {
    const [params, setParams] = useSearchParams();
    const [foundToken, setFoundToken] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        console.log(params);
        let token = params.get("token");
        if (!token) {
            setFoundToken(false);
            return;
        } else {
            setFoundToken(true);
        }

        API.post("/users/email-confirmation/" + token).then(response => {
            console.log(response);
            if (response.status === 200) {
                console.log("redirecting")
                navigate("/login");
            }
        }).catch(error => {
            if (error.status === 400) {
                setError("The link is expired please create the account again!");
            }
        })
    }, []);

    return (
        <div className="bg-gradient-dark text-white d-flex align-items-center justify-content-center h-100 p-5 m-5 text-center">
            {(foundToken && !error) && (
                <div className="spinner-border" role="status">
                </div>
            )}
            {(!foundToken && !error) && (
                <div>
                    <strong><p className="display-5 text-warning fw-bold">
                    Could not find a token to validate your email
                    </p></strong>
                    <Row>
                        <Button as={Col} onClick={(e) => {navigate("/login")}} className="m-5">Login</Button>
                        <Button as={Col} onClick={(e) => {navigate("/signup")}} className="m-5">Signup</Button>
                    </Row>
                </div>
            )}
            {error !== "" && (
                <div>
                    <strong><p className="display-5 text-warning fw-bold">
                        The link has expired please try making the account again
                    </p></strong>
                    <Row>
                        <Button as={Col} onClick={(e) => {navigate("/login")}} className="m-5">Login</Button>
                        <Button as={Col} onClick={(e) => {navigate("/signup")}} className="m-5">Signup</Button>
                    </Row>
                </div>
            )}
        </div>
    );
}

export default EmailConfirmation;